import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DialogTitle } from '@monorepo/nova-ui';

export const MidnightModalHeader: FC = () => {
  const { t } = useTranslation(['dashboardTemplates']);

  return (
    <DialogTitle
      id="midnight-values-modal-title"
      sx={(theme) => ({
        fontSize: {
          xs: theme.typography.pxToRem(28),
        },
      })}
    >
      {t('dashboardTemplates:midnight_values_last_60_days')}
    </DialogTitle>
  );
};
